import store from '@/state/store';
import projectSlice from '@/state/project.slice';
import authenticationSlice from '@/state/authentication.slice';
import commonSlice from '@/state/common.slice';
import { Event, Profile } from '@bimdata/definitions/dto';
import { ProjectEventType } from '@bimdata/definitions/const';

export default async function (event: Event, profile: Profile) {
  const { projectCode, userId, invitationId } = event.data;
  if (userId === profile.id) {
    if (invitationId) {
      if (event.type === ProjectEventType.EXCLUDE) {
        store.dispatch(commonSlice.actions.removeLastProjectInviteNotification(projectCode));
      }
      store.dispatch(authenticationSlice.actions.removeInvitation(invitationId));
    } else {
      store.dispatch(projectSlice.actions.removeProject(projectCode));
    }
  } else {
    if (invitationId) {
      store.dispatch(
        projectSlice.actions.removeInvitations({
          code: projectCode,
          ids: [invitationId],
        })
      );
    } else {
      store.dispatch(
        projectSlice.actions.removeParticipants({
          code: projectCode,
          ids: [userId],
        })
      );
    }
  }
}